<div
  [ngStyle]="iconContainerStyle || {}"
  class="icon-container user-select-none"
  (click)="disabled ? {} : onIconClick.emit()"
>
  @if (icon) {
  <div
    [container]="avoidContainerAsBody ? '' : 'body'"
    [placement]="tooltipPlacement || 'bottom auto'"
    [ngbTooltip]="tooltip"
    [tooltipClass]="'custom-tooltip'"
    [ngClass]="getClass()"
    [ngStyle]="
      hoverClass || roundedIcon
        ? { backgroundColor: disabled ? 'lightgrey' : fillColor }
        :  { color: disabled ? 'lightgrey' : (color || 'var(--btn-primary)') }
    "
    [class]="roundedIcon ? 'custom-filled-icon' : 'holder h-100 d-flex'"
  >
    <span [ngClass]="filledIcon ? 'material-symbols-rounded': 'material-symbols-outlined'" [ngStyle]="{fontSize: iconSize}">{{ getIcon() }}</span>
  </div>
  } @else {
  <span></span>
  }
</div>
